export default class OffMenuToggler {
  constructor(rootNode) {
    this.refs = {
      rootNode,
      mainContainer: document.querySelector('.Main'),
      menuContainer: document.querySelector(`#${rootNode.dataset.menu}`),
    };

    this.triggerClick = this.triggerClick.bind(this);
    this.addClickHandler();
  }

  addClickHandler() {
    this.refs.rootNode.addEventListener('click', e => {
      e.stopPropagation();

      const menuClasses = this.refs.menuContainer.classList;
      const mainClasses = this.refs.mainContainer.classList;
      const menuPosition = this.refs.menuContainer.dataset.position || 'left';

      if (menuClasses.contains('is-visible')) {
        menuClasses.remove('is-visible');
        mainClasses.remove(`move-${menuPosition}`);
        this.refs.mainContainer.removeEventListener('click', this.triggerClick);
      } else {
        menuClasses.add('is-visible');
        mainClasses.add(`move-${menuPosition}`);
        this.refs.mainContainer.addEventListener('click', this.triggerClick, { once: true });
      }
    });
  }

  triggerClick(e) {
    this.refs.rootNode.click();
  }
}
